import { types } from '../../types/types';
import { startSpinner, finishSpinner } from "../ui/spinner";
import { handleErrorApi } from '../../helpers/randoms';
import ContratacionesReportesService from '../../services/ContratacionesReportesService';


//ACA VAN A ESTAR TODOS LOS REPORTES DE LA SECCION REPORTES

//RED
export const fetchTraerContratosRed = () => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.traerContratosRedStart })
  try {
    const response = await ContratacionesReportesService.traerContratosRed()
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.traerContratosRedSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner())
    dispatch({ type: types.traerContratosRedError })
    handleErrorApi(dispatch, error, "Error al traer los contratos", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const generatePDFContratosRed = () => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesReportesService.generarPdfContratosRed();
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      window.open(URL.createObjectURL(body));

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el pdf",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const generateExcelContratosRed = () => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesReportesService.generarExcelContratosRed();
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = `Contratos Red.xlsx`;
      a.click();

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

//NOMENCLADOR
export const generatePDFNomenclador = () => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesReportesService.generatePDFNomenclador();
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      window.open(URL.createObjectURL(body));

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el pdf",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const generateExcelNomenclador = () => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesReportesService.generateExcelNomenclador();
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = `Contratos Nomenclador.xlsx`;
      a.click();

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const fetchPrestadores = (idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos) => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.traerPrestadoresFiltradosStart })
  try {
    const response = await ContratacionesReportesService.traerPrestadorReporte(idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.traerPrestadoresFiltradosSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch({ type: types.traerPrestadoresFiltradosError })
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los datos.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  };
}

export const generateExcelPrestadores = (idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesReportesService.getExcelPrestadores(idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = `Contratos Prestadores.xlsx`;
      a.click();

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const generatePDFPrestadores = (idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesReportesService.getPDFPrestadores(idTipoEfector, idSubTipoEfector, idProvincia, idLocalidad, idRanking, inactivos);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      window.open(URL.createObjectURL(body));

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el pdf",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};


export const fetchPracticaPorConvenio = (codigoPractica, idLocalidad, idProvincia) => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.traerPracticaStart });
  try {
    const response = await ContratacionesReportesService.traerPracticaReporte(codigoPractica, idLocalidad, idProvincia);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.traerPracticaSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch({ type: types.traerPracticaError })
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los datos.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const cleanPracticaPorConvenio = () => {
  return { type: types.CleanPractica };
};

export const generatePDFPracticaXConvenio = (codigoPractica, idLocalidad, idProvincia) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesReportesService.getPDFPracticaXConvenio(codigoPractica, idLocalidad, idProvincia);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      window.open(URL.createObjectURL(body));

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el pdf",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const generateExcelPracticaXConvenio = (codigoPractica, idLocalidad, idProvincia) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesReportesService.getExcelPracticaXConvenio(codigoPractica, idLocalidad, idProvincia);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = `Practica Por Convenio.xlsx`;
      a.click();

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};